import * as React from "react";
import { HighlightedContent, HighlightedContentItem } from "@grandvisionhq/content";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachPageable } from "../../../../hocs/hocs/with-bloomreach-pageable.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { useBloomreachLinks } from "../../../../hooks/hooks/use-bloomreach-links.js";
import { parseBloomreachImage } from "../../../../utils/utils/parse-bloomreach-image.js";
const CmsArticleCollectionItem = withEditableContent(({ content }) => {
  const { coverImage, url, title, summary } = content;
  const [link] = useBloomreachLinks([{ url: url ?? "#" }]);
  const image = parseBloomreachImage(coverImage);
  if (!image) {
    console.error("Missing coverImage");
    return null;
  }
  return /* @__PURE__ */ React.createElement(HighlightedContentItem, { image: image.original, text: summary, title, link });
});
const CmsArticleCollection = ({ content }) => /* @__PURE__ */ React.createElement(HighlightedContent, null, content.items.map((item) => /* @__PURE__ */ React.createElement(CmsArticleCollectionItem, { key: item.id, content: item })));
const CmsArticleCollection$1 = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachPageable,
  withEditableContent,
  withAnchor
)(CmsArticleCollection);
export {
  CmsArticleCollection,
  CmsArticleCollectionItem,
  CmsArticleCollection$1 as default
};
//# sourceMappingURL=ArticleCollection.js.map
